import React from 'react';


const PrimaryButton = ({ ButtonText, MaxWidth , MinWidth,MaxHeight,ButtonFunction ,BorderRadius}) => {

    return (
        <>
            <button className='primaryBtn' style={{ maxWidth: `${MaxWidth}rem`, minWidth: `${MinWidth}rem`, maxHeight: `${MaxHeight}rem`, borderRadius: `${BorderRadius}rem`}} onClick={ButtonFunction}>{ButtonText}</button>
        </>
    );
}

export default PrimaryButton;

